import { StaffInformationBlock } from '@urbanx/agx.support.client';
import { AgxColumn, AgxRow, AgxTypography } from '@urbanx/agx.ui-components2';
import PoisonQueueInformationTidbit from './PoisonQueueInformationTidbit';
import PoisonQueuePhotoDisplay from './PoisonQueuePhotoDisplay';

const PoisonQueueStaffInformation = ({
  staffInformation,
}: {
  staffInformation?: StaffInformationBlock;
}) => {
  const { id, title, fullName, phoneNumber, roles, photoUri } = staffInformation || {};

  if (!staffInformation) return null;

  return (
    <AgxColumn gap="spacing-md" fill>
      <AgxTypography id="staff-information" type="heading" size="small">
        Staff Information
      </AgxTypography>

      <AgxRow fill gap="spacing-lg">
        <PoisonQueuePhotoDisplay photoUri={photoUri} />

        <AgxColumn gap="spacing-md" fill>
          <PoisonQueueInformationTidbit label={'Staff Id'} value={id} />

          <PoisonQueueInformationTidbit label={'Full Name'} value={fullName} />

          <PoisonQueueInformationTidbit label={'Title'} value={title} />

          <PoisonQueueInformationTidbit label={'Phone Number'} value={phoneNumber} />

          <PoisonQueueInformationTidbit label={'Roles'} value={roles} />
        </AgxColumn>
      </AgxRow>
    </AgxColumn>
  );
};

export default PoisonQueueStaffInformation;
